import { render, staticRenderFns } from "./wageTongcheng.vue?vue&type=template&id=511609ef&"
import script from "./wageTongcheng.vue?vue&type=script&lang=js&"
export * from "./wageTongcheng.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports